import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import StartBiblesImg from "../../../assets/StartBibles.jpeg";
import AppleStoreIcon from "../../../assets/AppleStoreIcon.png";
import GooglePlayIcon from "../../../assets/GooglePlayIcon.png";
import CustomGoogleMap from "./Map";
import { withFirebase } from "../../../utils/Firebase";

const Landing = ({ firebase }) => {
  const [locations, setLocations] = useState([]);
  const [report, setReport] = useState();

  useEffect(() => {
    if (firebase && !report) {
      firebase
        .report("global")
        .get()
        .then((doc) => setReport(doc.data()));
    }
    if (firebase && locations.length < 1) {
      firebase
        .locations()
        .get()
        .then((querySnapShot) => {
          const locs = [];
          querySnapShot.forEach((doc) => {
            locs.push(doc.data());
          });
          setLocations(locs);
          console.log(locs);
        });
    }
  }, [locations, firebase]);
  return (
    <div className="landing container">
      <div className="landing__headerImg">
        <img src={StartBiblesImg} />
      </div>
      <p className="landing__subtitle">
        A first step in oral Bible translation of the{" "}
        <span className="landing__bibleless">Bible-less languages.</span>
      </p>
      <div className="landing__appLinks">
        <a
          href="https://play.google.com/store/apps/details?id=com.startbibles.robwiebe"
          target="_blank"
          className="landing__link"
        >
          <img src={GooglePlayIcon} />
        </a>
        <a
          href="https://apps.apple.com/us/app/id1533748269"
          target="_blank"
          className="landing__link"
        >
          <img src={AppleStoreIcon} />
        </a>
      </div>
      <div className="videoPlayer">
        <ReactPlayer
          url={"https://youtu.be/TzKS23GukjU"}
          // playing
          controls
        />
      </div>
      <div className="statistics">
        <div className="statistics__dataPoint">
          <div className="statistics__dataPoint__text">
            Translations Recorded:
          </div>
          <div className="statistics__dataPoint__num">
            {report ? report.translations : "..."}
          </div>
        </div>
        <div className="statistics__dataPoint">
          <div className="statistics__dataPoint__text">
            Languages with Bibles Started:
          </div>
          <div className="statistics__dataPoint__num">
            {report ? report.languagesCompleted.length : "..."}
          </div>
        </div>
      </div>
      <div className="main_map_div">
        <CustomGoogleMap locations={locations} />
      </div>
      <p className="landing__footer">
        © Start Bibles {new Date().getFullYear()}
      </p>
    </div>
  );
};

export default withFirebase(Landing);
